const HTTP_METHODS = [
  {
    text: '-----',
    value: '',
  },
  {
    text: 'GET',
    value: 'get',
  },
  {
    text: 'POST',
    value: 'post',
  },
  {
    text: 'PUT',
    value: 'put',
  },
  {
    text: 'DELETE',
    value: 'delete',
  },
  {
    text: 'PATCH',
    value: 'patch',
  },
];

export default HTTP_METHODS;
